export const FINANCE_BASE = '/portal/finance';

export const FINANCE_TABS = [
  { id: 'all', label: 'All', path: 'all', emoji: '📋' },
  { id: 'analytics', label: 'Analytics', path: 'analytics', emoji: '📊' },
  { id: 'margin', label: 'Margin Calculator', path: 'margin', emoji: '🧮' },
  { id: 'overhead-calculator', label: 'Overhead', path: 'overhead-calculator', emoji: '💸' },
  { id: 'labor-burden', label: 'Labor Burden', path: 'labor-burden', emoji: '👷' },
  { id: 'materials', label: 'Materials', path: 'materials', emoji: '📂' },
  { id: 'goals', label: 'Goals', path: 'goals', emoji: '🎯', hiddenInNav: true },
];

export const FINANCE_NAV_TABS = FINANCE_TABS.filter((tab) => !tab.hiddenInNav);
export const DEFAULT_FINANCE_TAB = 'all';

export function getActiveFinanceTabId(pathname) {
  if (!pathname?.startsWith(FINANCE_BASE)) return DEFAULT_FINANCE_TAB;
  const remainder = pathname.slice(FINANCE_BASE.length).replace(/^\//, '');
  if (!remainder) return DEFAULT_FINANCE_TAB;
  const firstSegment = remainder.split('/')[0];
  for (const tab of FINANCE_TABS) {
    const paths = tab.matchPaths || [tab.path];
    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) return tab.id;
  }
  return DEFAULT_FINANCE_TAB;
}

export function getFinanceTabHref(tab) {
  if (tab.path === '' || tab.id === 'all') return `${FINANCE_BASE}/all`;
  return `${FINANCE_BASE}/${tab.path}`;
}
